import React from 'react';

import { Form, Checkbox, Input, Select } from 'antd';

import { DURATION_OPTIONS } from '../../../../constants';
import { AD_PRODUCT_OPTIONS, AD_PRODUCT_TYPE_OPTIONS, FORM_FIELDS } from '../../constants';
import { StyledFieldsWrapper, StyledSelectSearch, MultipleSelect } from '../styles';

const { Option } = Select;

export const DemandParameters = (props) => {
  const {
    handleChangeCreativeDuration,
    creativeDurationSelect,
    handleBidStateFilterOption,
    bidStates,
    renderOptions,
    handleChangeWinnerAuction,
    supplySource,
    getOptionsByFieldName,
    winnerAuctionSelect,
    isDspDisabled,
    bidDealTypes,
    isAdProductTypeDisabled,
    handleChangeAdProduct,
    handleChangeAdProductType,
  } = props;
  return (
    <StyledFieldsWrapper>
      <Form.Item label={FORM_FIELDS.WINNING_AUCTION.label} name={FORM_FIELDS.WINNING_AUCTION.name}>
        <MultipleSelect
          placeholder="Select"
          showSearch={false}
          tagRender={({ label }) => <>&nbsp;{label}</>}
          optionLabelProp="label"
          mode="multiple"
          onChange={(value) => handleChangeWinnerAuction({ fieldName: FORM_FIELDS.WINNING_AUCTION.name, value })}
          menuItemSelectedIcon={<></>}
          allowClear
          disabled={!supplySource}
        >
          {getOptionsByFieldName(FORM_FIELDS.WINNING_AUCTION.name).map((itemName) => (
            <Option key={itemName} value={itemName} label={itemName}>
              <Checkbox checked={winnerAuctionSelect.indexOf(itemName) >= 0} style={{ pointerEvents: 'none' }}>
                {itemName}
              </Checkbox>
            </Option>
          ))}
        </MultipleSelect>
      </Form.Item>
      <Form.Item label={FORM_FIELDS.ADVERTISER.label} name={FORM_FIELDS.ADVERTISER.name}>
        <Input allowClear />
      </Form.Item>
      <Form.Item label={FORM_FIELDS.AD_PARTNER_DSP.label} name={FORM_FIELDS.AD_PARTNER_DSP.name}>
        <Input disabled={isDspDisabled} allowClear />
      </Form.Item>
      <Form.Item label={FORM_FIELDS.BUYER_DEAL_ID.label} name={FORM_FIELDS.BUYER_DEAL_ID.name}>
        <Input allowClear />
      </Form.Item>
      <Form.Item label={FORM_FIELDS.CREATIVE_ID.label} name={FORM_FIELDS.CREATIVE_ID.name}>
        <Input allowClear />
      </Form.Item>
      <Form.Item label={FORM_FIELDS.SYSTEM_DEAL_ID.label} name={FORM_FIELDS.SYSTEM_DEAL_ID.name}>
        <Input allowClear />
      </Form.Item>
      <Form.Item label={FORM_FIELDS.BID_STATE.label} name={FORM_FIELDS.BID_STATE.name}>
        <StyledSelectSearch placeholder="Select" filterOption={handleBidStateFilterOption} allowClear showSearch>
          {bidStates?.map(renderOptions)}
        </StyledSelectSearch>
      </Form.Item>
      {/* Hidden until the BE part is ready
      <Form.Item label={FORM_FIELDS.CREATIVE_NAME.label} name={FORM_FIELDS.CREATIVE_NAME.name}>
        <Input allowClear maxLength={255} showCount />
      </Form.Item>
      */}
      <Form.Item label={FORM_FIELDS.CREATIVE_DURATION.label} name={FORM_FIELDS.CREATIVE_DURATION.name}>
        <MultipleSelect
          placeholder="Select"
          showSearch={false}
          tagRender={({ label }) => <>&nbsp;{label}</>}
          optionLabelProp="label"
          mode="multiple"
          onChange={handleChangeCreativeDuration}
          menuItemSelectedIcon={<></>}
          allowClear
        >
          {DURATION_OPTIONS.map(({ label, value }) => (
            <Option key={value} value={value} label={label}>
              <Checkbox checked={creativeDurationSelect.indexOf(value) >= 0} style={{ pointerEvents: 'none' }}>
                {label + ' seconds'}
              </Checkbox>
            </Option>
          ))}
        </MultipleSelect>
      </Form.Item>
      <Form.Item label={FORM_FIELDS.MEDIA_FILE_URL.label} name={FORM_FIELDS.MEDIA_FILE_URL.name}>
        <Input allowClear />
      </Form.Item>
      <Form.Item label={FORM_FIELDS.RECEIVED_BID_DEAL_ID.label} name={FORM_FIELDS.RECEIVED_BID_DEAL_ID.name}>
        <Select placeholder="Select" allowClear>
          {bidDealTypes?.map(renderOptions)}
        </Select>
      </Form.Item>
      <Form.Item label={FORM_FIELDS.AD_PRODUCT.label} name={FORM_FIELDS.AD_PRODUCT.name}>
        <Select placeholder="Select" allowClear onChange={handleChangeAdProduct}>
          {AD_PRODUCT_OPTIONS.map(renderOptions)}
        </Select>
      </Form.Item>
      <Form.Item label={FORM_FIELDS.AD_PRODUCT_TYPE.label} name={FORM_FIELDS.AD_PRODUCT_TYPE.name}>
        <Select placeholder="Select" allowClear disabled={isAdProductTypeDisabled} onChange={handleChangeAdProductType}>
          {AD_PRODUCT_TYPE_OPTIONS.map(renderOptions)}
        </Select>
      </Form.Item>
      {/* Hidden until the BE part is ready *
    <Form.Item label={FORM_FIELDS.DEAL_NAME.label} name={FORM_FIELDS.DEAL_NAME.name}>
      <Input maxLength={100} allowClear />
    </Form.Item>
    <Form.Item label={FORM_FIELDS.BUYER_SEAT_ID.label} name={FORM_FIELDS.BUYER_SEAT_ID.name}>
      <Input allowClear />
    </Form.Item>
    <Form.Item label={FORM_FIELDS.PACKAGE_NAME.label} name={FORM_FIELDS.PACKAGE_NAME.name}>
      <Input maxLength={100} allowClear />
    </Form.Item>*/}
    </StyledFieldsWrapper>
  );
};
